import { apiClient } from '@/shared/api';

import type { OkeiUnit } from '../model/types';

const BASE = '/api/v1/catalog/units';

/**
 * The OKEI unit-of-measure dictionary (Russia's national classifier of units of measure,
 * plan-catalog-008) — global, non-tenant-scoped reference data seeded and owned by
 * web-catalog-master-service; the BFF proxies it as-is. Backs the unit-of-measure Autocomplete
 * that replaces the legacy free-text product `unit` field (`ProductEditPage`); see
 * `hooks/index.ts`'s `useOkeiUnits` for the aggressively-cached query wrapper.
 */
export const fetchOkeiUnits = async (): Promise<OkeiUnit[]> =>
  (await apiClient.get<OkeiUnit[]>(`${BASE}/okei`)).data;
